import React, { useCallback, useEffect, useState } from 'react';
import { BellRing, Loader2, RefreshCcw } from 'lucide-react';
import api from '@/lib/axios';

export default function MarketplaceAlertsPanel() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  const [estado, setEstado] = useState('');

  const load = useCallback(async () => {
    setLoading(true); setErr('');
    try { setData((await api.get(`/admin/marketplace/alerts${estado ? `?estado=${estado}` : ''}`)).data); }
    catch (e) { setErr(e.response?.data?.detail || 'Falha a carregar.'); }
    finally { setLoading(false); }
  }, [estado]);

  useEffect(() => { load(); }, [load]);

  const Card = ({ label, value }) => (
    <div className="rounded-xl border border-slate-200 p-3 text-center">
      <p className="text-lg font-bold text-slate-900">{value}</p>
      <p className="text-[10px] font-semibold uppercase text-slate-500">{label}</p>
    </div>
  );

  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm" data-testid="alerts-panel">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="inline-flex items-center gap-2 text-base font-bold text-slate-900 md:text-lg">
          <BellRing className="h-5 w-5 text-emerald-600" /> Alertas públicos "Avise-me"
        </h2>
        <div className="flex items-center gap-2">
          <select value={estado} onChange={(e) => setEstado(e.target.value)} className="rounded-lg border border-slate-300 px-2 py-1.5 text-xs" data-testid="alerts-filter">
            <option value="">Todos</option><option value="pendente">Pendentes</option>
            <option value="confirmado">Confirmados</option><option value="cancelado">Cancelados</option>
          </select>
          <button type="button" onClick={load} className="inline-flex items-center gap-1.5 rounded-lg border border-slate-300 px-2.5 py-1.5 text-xs font-semibold text-slate-600">
            <RefreshCcw className="h-3.5 w-3.5" /> Atualizar
          </button>
        </div>
      </div>
      {err && <p className="mt-2 text-xs font-semibold text-red-600">{err}</p>}
      {loading ? (
        <p className="mt-4 flex items-center gap-2 text-xs text-slate-500"><Loader2 className="h-4 w-4 animate-spin" /> A carregar...</p>
      ) : data && (
        <>
          <div className="mt-3 grid grid-cols-3 gap-2">
            <Card label="Pendentes" value={data.stats?.pendente || 0} />
            <Card label="Confirmados" value={data.stats?.confirmado || 0} />
            <Card label="Cancelados" value={data.stats?.cancelado || 0} />
          </div>
          {data.simulado && <p className="mt-2 rounded bg-amber-50 px-2 py-1 text-[11px] font-semibold text-amber-700" data-testid="alerts-simulado">Modo simulado — sem envio real de emails no preview.</p>}
          <ul className="mt-3 space-y-1.5" data-testid="alerts-list">
            {(data.items || []).length === 0 && <li className="text-xs text-slate-500">Sem subscrições.</li>}
            {(data.items || []).map((it) => (
              <li key={it.id} className="rounded-lg border border-slate-200 px-3 py-2 text-[11px]">
                <div className="flex items-center justify-between gap-2">
                  <span className="font-semibold text-slate-800">{it.email_mascarado}</span>
                  <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold ${it.estado === 'confirmado' ? 'bg-emerald-50 text-emerald-700' : it.estado === 'pendente' ? 'bg-amber-50 text-amber-700' : 'bg-slate-100 text-slate-500'}`}>{it.estado}</span>
                </div>
                <p className="text-slate-500">Critérios: {[it.criterios?.distrito, it.criterios?.finalidade, it.criterios?.tipo].filter(Boolean).join(' · ') || 'qualquer'} · Frequência: {it.frequencia}</p>
              </li>
            ))}
          </ul>
        </>
      )}
    </section>
  );
}
